import { reduxForm } from 'redux-form';
import { connect } from 'react-redux'
import { fetchSimplifiedProducts } from '../../actions/products_actions';
import { fetchReturnBatch } from '../../actions/inventories_actions';

import InventoryInfo from '../../components/Purchase/inventoryInfo';

function mapStateToProps(state) {
    return {
        simplifiedProducts: state.products.simplifiedProducts,
        simplifiedProductsIsLoading: state.products.simplifiedProductsIsLoading,
        simplifiedProductsError: state.products.simplifiedProductsError,
    }

}

const inventoryInfo = reduxForm({
    form: 'inventoryInfo',
    destroyOnUnmount: false,
})(InventoryInfo);

export default connect(mapStateToProps, { fetchSimplifiedProducts, fetchReturnBatch })(inventoryInfo)



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/inventoryInfo.jsx